<template>
    <div class="tabar" v-show="isShowTabbar">
        
        <div class="tab">
            <div class="tab-item">
                <router-link to="/home" >
                    <div class="tab-icon"><i class="iconfont icon-yidiandiantubiao04"></i></div>
                    <div class="tab-text">首页</div>
                </router-link>
            </div>
            <div class="tab-item">
                <a @click="tel">
                    <div class="tab-icon"><i class="iconfont icon-kefu"></i></div>
                    <div class="tab-text">客服</div>
                </a>
            </div>
            <div class="tab-item">
                <router-link to="/shoplist">
                    <div class="tab-icon"><i class="iconfont icon-dingdan1"></i></div>
                    <div class="tab-text">我的订单</div>
                </router-link>
            </div>
            <div class="tab-item">
                <router-link to="/user">
                    <div class="tab-icon"><i class="iconfont icon-user"></i></div>
                    <div class="tab-text">个人中心</div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        },
        computed: {
            isShowTabbar() {
                let routeLength = this.$route.path.split('/').length;
                return routeLength > 2 ? false : true
            }
        },
        methods: {
            tel: function() {
                this.$dialog.confirm({
                    title: '提示',
                    message: '确定拨打电话：0512-56995682',
                   
                }).then(() => {
                    // on confirm
                    window.location.href='tel:0512-56995682'
                }).catch(() => {
                    // on cancel
                });
            }
        }
    }
</script>

<style lang="less">
    .iconfont {
        color: #333;
        font-size: 24px;
        line-height: 1.4rem;
    }
    .active .iconfont {
        color: #99C51D;
    }
     .active .tab-text {
        color: #99C51D;
    }
    .tabar {
        .tab {
            position: fixed;
            bottom: 0;
            left: 0;
            display: flex;
            width: 100%;
            height: px2rem(120px);
            line-height: px2rem(120px);
            background: #fff;
            border-top: 1px solid #C7C6C6;
            padding-top: 8px;
            
            &:after {
                display: block;
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                border-top: 1px solid rgba(7, 17, 27, 0.1);
                content: '';
            }
            .tab-item {
                flex: 1;
                text-align: center;
                a {
                    display: block;
                    font-size: 14px;
                    color: rgb(77, 85, 93);
                    &.active {
                        color: #000;
                        text-decoration: none;
                    }
                    .tab-icon {
                        width: px2rem(100px);
                        height: px2rem(50px);
                        margin: 0 auto 5px auto;
                        text-align: center;
                        img {
                            width: 100%;
                        }
                    }
                    .tab-text {
                        height: px2rem(80px);
                        line-height: px2rem(80px);
                        text-align: center;
                    }
                }
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/tabar.vue